// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {};

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {};

// APP CONFIG
export const $themeConfig = {
  app: {
    // eslint-disable-next-line no-nested-ternary
    appName: process.env.VUE_APP_PROVIDER === 'tingtong' ? "TingTong" : (process.env.VUE_APP_PROVIDER === 'vmarket' ? "VMarket" : "Resident"), // Will update name in navigation menu (Branding)
    // eslint-disable-next-line global-require
    appLogoImage: require("@/assets/images/logo/logo.svg"), // Will update logo in navigation menu (Branding)
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    routerTransition: "zoom-fade", // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: "vertical", // vertical, horizontal
    contentWidth: "full", // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "sticky", // static , sticky , floating, hidden
      backgroundColor:  "primary", // BS color options [primary, success, etc]
    },
    footer: {
      type: "sticky", // static, sticky, hidden
    },
    customizer: false,
    gallery: false,
    enableScrollToTop: true,
  },
};

export const $brandConfig = {
  tingtong: {
    // eslint-disable-next-line global-require
    loginBgImage: require("@/assets/images/banner/auth.png"),
    loginBgColorClass: 'bg-primary',
    loginWelcomeText: 'Xin chào chiến binh TingTong 👋',
    loginDescriptionText: 'Tại TingTong chúng tôi khát khao trong việc tiên phong đi đầu và tạo ra các tiêu chuẩn dành riêng cho cộng đồng thuê trọ.',
  },
  resident: {
    // eslint-disable-next-line global-require
    loginBgImage: require("@/assets/images/pages/login-v2.svg"),
    loginBgColorClass: 'bg-primary',
    loginWelcomeText: 'Đăng nhập! 👋',
    loginDescriptionText: 'Bất động sản, tài chính, khách hàng... và hơn thế nữa',
  },
  vmarket: {
    // eslint-disable-next-line global-require
    loginBgImage: require("@/assets/images/pages/login-v2.svg"),
    loginBgColorClass: 'bg-primary',
    loginWelcomeText: 'Đăng nhập! 👋',
    loginDescriptionText: 'Bắt đầu quản lý chợ hiệu quả, thông minh',
  },
};
